import { createFileRoute } from '@tanstack/react-router';
import { FigmaAuthPage } from '@/components/figma-auth/FigmaAuthPage';

interface FigmaAuthSearch {
  code?: string;
}

export const Route = createFileRoute('/figma-auth')({
  validateSearch: (search: Record<string, unknown>): FigmaAuthSearch => ({
    code: typeof search.code === 'string' ? search.code : undefined,
  }),
  component: FigmaAuthPage,
});
